export default __webpack_public_path__ + "static/media/logo2.7a9742f5.svg";